// Configuração do Asaas
// Este arquivo contém as credenciais do Asaas
// Em produção, use variáveis de ambiente adequadas

export const asaasConfig = {
  sandbox: {
    url: 'https://api-sandbox.asaas.com/v3',
    apiKey: '$aact_hmlg_000MzkwODA2MWY2OGM3MWRlMDU2NWM3MzJlNzZmNGZhZGY6OjYxZjVmMDc4LWU3YTItNGU5MS05NjQzLWQwZmU2OWRlMTkzMTo6JGFhY2hfMTUzYzVlYTQtYWNkYy00MDRhLWFiMzEtZGIwMzQ3NWI1NWRk'
  },
  production: {
    url: 'https://api.asaas.com/v3',
    apiKey: '$aact_prod_000MzkwODA2MWY2OGM3MWRlMDU2NWM3MzJlNzZmNGZhZGY6OjU0MDk3NWRiLWU1MTQtNDgzNi05M2M4LTIwMjAyODdlMGFhYzo6JGFhY2hfNjkwNjUwOGUtZTk1Yi00YTNhLTliYjItYmE5ZTk2ZDQ1MmNm'
  }
};

// Usar sandbox por padrão
export const getAsaasConfig = () => {
  // Tenta usar variáveis de ambiente primeiro
  if (process.env.REACT_APP_URL_ASAAS && process.env.REACT_APP_APIKEY_ASAAS) {
    return {
      url: process.env.REACT_APP_URL_ASAAS,
      apiKey: process.env.REACT_APP_APIKEY_ASAAS
    };
  }
  
  // Fallback para configuração hardcoded
  return asaasConfig.sandbox;
};
